import React, {useEffect, useState, useContext } from "react";
import { FaGoogle, FaApple, FaFacebook, FaInstagram } from "react-icons/fa";
import { MdEmail, MdLock } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import logo from "../assets/rentastic.png";
import bgImage from "../assets/toys-bg.png"; 
import { AuthContext } from "../../context/AuthContext"; // ✅ Import Context
import { G_LOGIN_URL } from "../../config/apiConfig";

const LoginForm = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  useEffect(() => {
  const user_id = localStorage.getItem("user_id");
  if (user_id) {
    navigate("/", { replace: true }); // redirect and replace history
  }
}, [navigate]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await login(email, password);

    if (res.success) {
      window.location.href = "/"; // ✅ Redirect after login
    } else {
      setError(res.message);
    }
  };

  return (
    <section
      className="min-h-screen flex justify-center md:justify-end items-center bg-cover bg-center"
      style={{ backgroundImage: `url("https://cdn.acsdev.in/Rentastic/toysb.png")` }}
    >
      <div className="w-full max-w-md sm:max-w-sm md:max-w-md lg:max-w-lg bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg p-6 sm:p-8 md:p-10 mx-4 md:mr-16 lg:mr-32">
        {/* Logo */}
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center bg-green-100 mb-3">
            <img src="https://cdn.acsdev.in/Rentastic/rentastic.png" alt="logo" className="w-10 h-10" />
          </div>
          <h1 className="text-lg font-bold text-gray-800">Rentastic Toys</h1>
          <p className="text-md font-semibold text-gray-900 mt-2">
            Let’s Get Started
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="mt-6 sm:mt-8 space-y-4">
           {error && <p className="text-red-500 text-sm">{error}</p>}
          <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500">
            <MdEmail className="text-red-500 text-lg mr-2" />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full py-2 outline-none text-gray-700 bg-transparent"
            />
          </div>

          <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500">
            <MdLock className="text-gray-500 text-lg mr-2" />
            <input
              type="password"
              placeholder="Password"
               value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full py-2 outline-none text-gray-700 bg-transparent"
            />
          </div>

          <div className="text-right">
            <button
              type="button"
              onClick={() => navigate("/forgot")}
              className="text-sm text-orange-500 hover:underline font-medium"
            >
              Forgot Password?
            </button>
          </div>

          <button
            type="submit"
            className="w-full bg-green-500 text-white font-semibold py-2 rounded-full shadow hover:bg-green-600 transition"
          >
            Login
          </button>
        </form>

        {/* OR Divider */}
        <div className="flex items-center my-6">
          <div className="flex-grow h-px bg-gray-300"></div>
          <span className="mx-2 text-sm text-gray-500">OR</span>
          <div className="flex-grow h-px bg-gray-300"></div>
        </div>

        {/* Social Login */}
        <div className="flex justify-center space-x-4">
          <button
            type="button"
            onClick={() => window.location.href = `${G_LOGIN_URL}`}
            className="p-2 rounded-full border hover:bg-gray-100"
          >
            <FaGoogle className="text-xl text-red-500" />
          </button>

          <button className="p-2 rounded-full border hover:bg-gray-100">
            <FaApple className="text-xl text-black" />
          </button>
          <button className="p-2 rounded-full border hover:bg-gray-100">
            <FaFacebook className="text-xl text-blue-600" />
          </button>
          <button className="p-2 rounded-full border hover:bg-gray-100">
            <FaInstagram className="text-xl text-pink-500" />
          </button>
        </div>

        {/* Sign Up & Guest */}
        <div className="text-center mt-6 text-sm text-gray-600">
          Don’t have an Account?{" "}
          <button
            type="button"
            onClick={() => navigate("/signup")}
            className="text-orange-500 font-semibold hover:underline"
          >
            Sign Up Now
          </button>
          {/* <p className="mt-2">
            Continue as a{" "}
            <button
              type="button"
              onClick={() => alert("Guest mode")}
              className="text-orange-500 font-semibold hover:underline"
            >
              Guest
            </button>
          </p> */}
        </div>
      </div>
    </section>
  );
};

export default LoginForm;
